<template>
    <v-container fluid>
        <v-fade-transition mode="out-in">
            <!-- <keep-alive> -->
            <router-view/>
            <!-- </keep-alive> -->
        </v-fade-transition>
    </v-container>
</template>

<script>
    export default {
        name: "Admin",
        components: {}
    };
</script>

<style scoped>

</style>
